import * as React from 'react';
import { useNote } from '@/hooks/useNote';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

export function NotesTabs() {
  const { t } = useTranslation();
  const { activeTab, setActiveTab } = useNote();

  return (
    <Tabs
      value={activeTab}
      onValueChange={setActiveTab}
    >
      <TabsList>
        <TabsTrigger value="anotacoes-privadas">{t('header.myNotes')}</TabsTrigger>
        <TabsTrigger value="anotacoes-de-turma">{t('header.classNotes')}</TabsTrigger>
        <TabsTrigger value="anotacoes-importantes">{t('header.importantNotes')}</TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
